import { useState, useEffect } from 'react';
import axios from 'axios';
import { DollarSign, Info } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import theme from '../theme';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BrokerPayoutsPage({ user }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPayouts();
  }, []);

  const fetchPayouts = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API}/broker/payouts`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(res.data);
    } catch (err) {
      toast.error('Failed to load payouts');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div style={{ padding: '32px', color: theme.colors.text.muted }}>Loading...</div>;
  }

  return (
    <div data-testid="broker-payouts-page">
      <div style={{ marginBottom: '32px' }}>
        <h1
          style={{
            fontFamily: theme.fonts.heading,
            fontSize: '28px',
            fontWeight: '700',
            color: theme.colors.text.primary,
            marginBottom: '8px',
          }}
        >
          Payouts
        </h1>
        <p style={{ color: theme.colors.text.secondary, fontSize: '15px' }}>
          Track your commission payouts and payment history.
        </p>
      </div>

      {/* Message banner */}
      {data?.message && (
        <div
          data-testid="broker-payouts-message"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '16px 20px',
            borderRadius: theme.radius.card,
            background: 'rgba(255, 193, 7, 0.08)',
            border: '1px solid rgba(255, 193, 7, 0.25)',
            marginBottom: '24px',
          }}
        >
          <Info size={20} color="#FFC107" />
          <p style={{ color: '#FFC107', fontSize: '14px', fontWeight: '500' }}>{data.message}</p>
        </div>
      )}

      {/* Upcoming */}
      <Card style={{ border: `1px solid ${theme.colors.borders}`, borderRadius: theme.radius.card, marginBottom: '20px' }}>
        <CardHeader>
          <CardTitle style={{ color: theme.colors.primary }}>Upcoming Payouts</CardTitle>
        </CardHeader>
        <CardContent>
          {data?.upcoming?.length > 0 ? (
            <p style={{ color: theme.colors.text.primary }}>Upcoming payouts will appear here.</p>
          ) : (
            <div className="text-center py-8">
              <DollarSign size={36} style={{ color: theme.colors.text.muted, margin: '0 auto 12px' }} />
              <p style={{ color: theme.colors.text.muted, fontSize: '14px' }}>No upcoming payouts</p>
            </div>
          )}
        </CardContent>
      </Card>

      {/* History */}
      <Card style={{ border: `1px solid ${theme.colors.borders}`, borderRadius: theme.radius.card }}>
        <CardHeader>
          <CardTitle style={{ color: theme.colors.primary }}>Payout History</CardTitle>
        </CardHeader>
        <CardContent>
          {data?.history?.length > 0 ? (
            <p style={{ color: theme.colors.text.primary }}>Payout history will appear here.</p>
          ) : (
            <div className="text-center py-8">
              <DollarSign size={36} style={{ color: theme.colors.text.muted, margin: '0 auto 12px' }} />
              <p style={{ color: theme.colors.text.muted, fontSize: '14px' }}>No payout history yet</p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
